import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingguardService  implements CanActivate{

  constructor(private route:Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {

    let toRet:boolean=false;
    
        if(sessionStorage.getItem("customer")!=null){
            toRet= true;
        }
    

    if(toRet){
        return toRet;
    }else{
        alert("PLEASE LOGIN TO PROCEED")
        this.route.navigate(["/signUp"]);
        return toRet;
        
    }
}
}
